import React, { useEffect, useState } from 'react'
import Cookies from 'universal-cookie'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { Modal, Row, Col, Button, Carousel, Form } from 'react-bootstrap'
import moment from 'moment'
import { readCookie } from '../../cookie'
import { ConfigProvider, DatePicker, Select, Pagination, Spin } from 'antd'
import enUS from 'antd/es/locale/en_US'
import { fetchStates } from '../shared/StateDistrictData'

const defaultTrainingDetails = {
  community_anchor: { name: '', phone_number: '', organization: '' },
  _id: '',
  date: '',
  location: {
    address: '',
    lat: 0,
    lng: 0,
    district: '',
    block: '',
    state: '',
    map_url: '',
  },
  village_name: '',
  attendee_type: '',
  attendees: 0,
  no_of_women: 0,
  facilitator: {
    address: { district: '', state: '', pincode: '' },
    _id: '',
    profilePictureUrl: '',
    name: '',
    mobileNumber: '',
    preferredLanguage: '',
  },
  photos: [],
  notes: '',
  next_steps: '',
  clfId: null,
  voId: [],
  shgId: [],
  project_id: '',
  createdAt: '',
  updatedAt: '',
  createdBy: '',
  attendance: [],
  newPhotos: [],
  ledBy: '',
  // Training-specific defaults
  title: '',
  topicsCovered: '',
  venue: '',
}

const cookies = new Cookies()
const { Option, OptGroup } = Select
const { RangePicker } = DatePicker

export const TrainingDetails = () => {
  const { projectId } = useParams()
  const [allDistricts, setallDistricts] = useState([])
  const [filterData, setfilterData] = useState({
    state: [],
    district: [],
    toDate: null,
    fromDate: null,
  })
  const [allStates, setallStates] = useState([])
  const [projectInfo, setprojectInfo] = useState(false)
  const [groupMeetings, setgroupMeetings] = useState([]) // using same state name to keep UI intact
  const [showInfoModel, setshowInfoModel] = useState(false)
  const [showInfoVisit, setshowInfoVisit] = useState(null)
  const [editInfoVisit, setEditInfoVisit] = useState(null)
  const [addTrainingDetails, setTrainingDetails] = useState(false)
  const [editTrainingDetails, setSeditTrainingDetails] = useState(false)
  const [loading, setloading] = useState(true)
  const [clusters, setClusters] = useState([])
  const [sizePerPage, setsizePerPage] = useState(500)
  const [page, setpage] = useState(1)
  const [trainees, setTrainees] = useState({})
  const [selectedCluster, setSelectedCluster] = useState()

  // ---------- Helpers for headers ----------
  const authHeaders = () => {
    const token = JSON.parse(readCookie('access_token') || 'null')
    return {
      source: 'humblebee_admin',
      Authorization: `Bearer ${token}`,
    }
  }

  // --- helpers: fetch clusters' trainees ---
  const fetchClusterTrainees = async (clustersArr = []) => {
    return Promise.all(
      clustersArr.map(async (cluster) => {
        try {
          const res = await fetch(
            `${process.env.REACT_APP_API_APP_FIELD_URL}/clusters/trainees/${cluster._id}`,
            {
              method: 'GET',
              headers: {
                ...authHeaders(),
              },
            }
          )
          const data = await res.json()
          setTrainees((prev) => ({ ...prev, [cluster._id]: data.trainees || [] }))
        } catch (e) {
          console.error('fetchClusterTrainees error', e)
          setTrainees((prev) => ({ ...prev, [cluster._id]: [] }))
        }
      })
    )
  }

  // --- fetch project detail, cluster details, states ---
  const fetchProjectDetail = () => {
    const currentToken = cookies.get('access_token')
    const api = `${process.env.REACT_APP_HUMBLEBEE_API_URL}/projects/${projectId}`
    fetch(api, {
      method: 'GET',
      headers: {
        authorization: `Bearer ${currentToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => setprojectInfo(data.project))
      .catch((error) => console.error('Error fetching project:', error))
  }

  const fetchState = async () => {
    const data = fetchStates()
    setallStates(data)
  }
  const resetFilter = () => {
    let filterData = {
      state: [],
      district: [],
      fromDate: null,
      toDate: null,
    }
    // console.log(page,sizePerPage);
    setfilterData(filterData)
    fetchData(page, sizePerPage, filterData)
  }
  // fetch cluster details and trainees then fetch trainings list
  const fetchClusterDetails = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_APP_FIELD_URL}/clusters/${projectId}`, {
        method: 'GET',
        headers: {
          ...authHeaders(),
        },
      })
      const json = await res.json()
      if (json?.clusters) {
        setClusters(json.clusters)
        fetchClusterTrainees(json.clusters)
      } else {
        setClusters([])
      }
    } catch (err) {
      console.error('fetchClusterDetails error', err)
    }
  }
  useEffect(() => {
    fetchClusterDetails()
    fetchProjectDetail()
    fetchState()
    fetchData(1, 500)
  }, [])


  // ---------- API helpers for trainings endpoints ----------

  // Keep photo upload helper (assumes same upload endpoint works for trainings)
  async function uploadGroupMeetingImages(files = [], { module = 'group-meeting' } = {}) {
    if (!files || files.length === 0) return []

    const fd = new FormData()
    files.forEach((file, i) => {
      fd.append('photos', file, file.name || `photo_${Date.now()}_${i}.jpg`)
    })
    fd.append('module', module)

    // keep previous upload path - if your backend uses a different training upload path change this
    const url = `${process.env.REACT_APP_API_APP_FIELD_URL}/group-meetings/uploadImages`
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          // don't set Content-Type for form-data
          ...authHeaders(),
        },
        body: fd,
      })
      if (!res.ok) {
        const txt = await res.text().catch(() => null)
        throw new Error(`uploadGroupMeetingImages failed: ${res.status} ${txt || res.statusText}`)
      }
      const data = await res.json()
      return data.photo_urls || data.photoUrls || []
    } catch (err) {
      console.error('uploadGroupMeetingImages error', err)
      throw err
    }
  }

  // Create or update training (POST /clusters/trainings)
  async function createOrUpdateTraining(body) {
    if (!body) throw new Error('Missing body for createOrUpdateTraining')
    const url = `${process.env.REACT_APP_API_APP_FIELD_URL}/clusters/trainings`
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...authHeaders(),
        },
        body: JSON.stringify(body),
      })
      if (!res.ok) {
        const txt = await res.text().catch(() => null)
        throw new Error(`createOrUpdateTraining failed: ${res.status} ${txt || res.statusText}`)
      }
      return res.json()
    } catch (err) {
      console.error('createOrUpdateTraining error', err)
      throw err
    }
  }

  // Delete training (DELETE /clusters/trainings/:id)
  async function deleteTraining(id) {
    if (!id) throw new Error('Missing id for deleteTraining')
    const url = `${process.env.REACT_APP_API_APP_FIELD_URL}/clusters/trainings/${id}`
    try {
      const res = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          ...authHeaders(),
        },
      })
      if (!res.ok) {
        const txt = await res.text().catch(() => null)
        throw new Error(`deleteTraining failed: ${res.status} ${txt || res.statusText}`)
      }
      return res.json()
    } catch (err) {
      console.error('deleteTraining error', err)
      throw err
    }
  }

  // Fetch trainings for a cluster: GET /clusters/trainings/cluster/:clusterId
  async function getTrainingsForProject(pid) {
    let targetClusters = clusters
    if (!Array.isArray(targetClusters) || targetClusters.length === 0) {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_APP_FIELD_URL}/clusters/${pid}`, {
          method: 'GET',
          headers: { ...authHeaders() },
        })
        const json = await res.json()
        if (json?.clusters && Array.isArray(json.clusters)) {
          targetClusters = json.clusters
          setClusters(json.clusters)
        }
      } catch (err) {
        console.error('Error fetching cluster list inside getTrainingsForProject', err)
      }
    }

    if (!Array.isArray(targetClusters) || targetClusters.length === 0) return []

    const clusterIds = targetClusters.map((c) => c._id)
    const all = await Promise.all(
      clusterIds.map(async (cid) => {
        try {
          const res = await fetch(`${process.env.REACT_APP_API_APP_FIELD_URL}/clusters/trainings/cluster/${cid}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              ...authHeaders(),
            },
          })
          if (!res.ok) {
            const txt = await res.text().catch(() => null)
            console.warn(`trainings cluster ${cid} fetch failed:`, res.status, txt)
            return []
          }
          const json = await res.json()
          // json might be { trainings: [...] } or an array directly
          if (Array.isArray(json)) return json
          if (json.trainings && Array.isArray(json.trainings)) return json.trainings
          if (json.data && Array.isArray(json.data)) return json.data
          return []
        } catch (err) {
          console.error('getTrainingsForProject cluster fetch error', err)
          return []
        }
      })
    )
    return all.flat()
  }

  // ---------- Build + validate payloads for training controller ----------

  function buildTrainingPayload(visit, { projectId, isUpdate = false } = {}) {
    if (!visit) return null

    const dateIso = visit.date ? new Date(visit.date).toISOString() : undefined

    // cluster id should be the selected cluster id (visit.cluster already stores _id)
    const clusterId = visit.cluster || (selectedCluster && selectedCluster._id) || visit.cluster_id || null

    const locationObj = {
      state: visit.location?.state || selectedCluster?.state || '',
      district: visit.location?.district || selectedCluster?.district || '',
      block: visit.location?.block || selectedCluster?.clusterName || '',
      address: visit.location?.address || visit.venue || '',
    }

    const body = {
      ...(isUpdate && visit._id ? { id: visit._id } : {}),
      date: dateIso,
      project_id: visit.project_id || projectId || (projectInfo && projectInfo._id) || '',
      cluster_id: clusterId,
      title: visit.title || visit.village_name || visit.venue || '',
      topics: visit.topicsCovered || visit.topics || '',
      description: visit.notes || visit.description || '',
      venue: visit.venue || visit.location?.address || '',
      location: typeof visit.location === 'string' ? visit.location : JSON.stringify(locationObj),
      status: visit.status || 'draft',
      attendance: Array.isArray(visit.attendance) ? visit.attendance : visit.attendance ? [visit.attendance] : [],
      lat: visit.location?.lat || visit.lat || '',
      long: visit.location?.lng || visit.long || '',
      photos: visit.photos || [],
      // keep clf/vo/shg if present (not required by training schema but helpful)
      clfId: visit.clfId || null,
      voId: Array.isArray(visit.voId) ? visit.voId : visit.voId ? [visit.voId] : [],
      shgId: Array.isArray(visit.shgId) ? visit.shgId : visit.shgId ? [visit.shgId] : [],
      community_anchor: visit.community_anchor || (visit.ledBy ? { name: visit.ledBy } : {}),
    }

    return body
  }

  function validateTrainingPayload(payload) {
    const missing = []
    if (!payload) return ['payload']
    if (!payload.project_id || String(payload.project_id).trim() === '') missing.push('project_id')
    if (!payload.cluster_id || String(payload.cluster_id).trim() === '') missing.push('cluster_id')
    if (!payload.topics || String(payload.topics).trim() === '') missing.push('topics')
    if (!payload.description || String(payload.description).trim() === '') missing.push('description')
    if (!payload.venue || String(payload.venue).trim() === '') missing.push('venue')
    // date is optional; attendance optional
    return missing
  }

  // ---------- UI handlers (create, update, delete) ----------

  const handleAddTraining = () => {
    setTrainingDetails(true)
    setEditInfoVisit({ ...defaultTrainingDetails, attendance: [], date: '', ledBy: '' })
  }

  const handleEditInfoModal = async () => {
    if (!showInfoVisit) return
    setshowInfoModel(false)
    setTrainingDetails(false)
    setSeditTrainingDetails(true)

    // find selCluster by matching cluster id or clusterName/block
    let selCluster = null
    if (showInfoVisit.cluster_id) {
      selCluster = clusters.find((c) => c._id === showInfoVisit.cluster_id)
    }
    if (!selCluster && showInfoVisit.location?.block) {
      selCluster = clusters.find((c) => c.clusterName === showInfoVisit.location.block)
    }

    setEditInfoVisit({
      ...showInfoVisit,
      attendance: showInfoVisit.attendance ?? [],
      date: showInfoVisit.date || showInfoVisit.updatedAt || '',
      ledBy: showInfoVisit.community_anchor?.name || showInfoVisit.ledBy || '',
      newPhotos: [],
      venue: showInfoVisit.venue ?? '',
      cluster: selCluster ? selCluster._id : showInfoVisit.cluster || showInfoVisit.cluster_id || '',
      attendence: showInfoVisit.attendence,
    })
    setSelectedCluster(selCluster)
  }

  const handleCloseEditModal = () => {
    setEditInfoVisit(null)
    setshowInfoModel(false)
    setTrainingDetails(false)
    setSeditTrainingDetails(false)
  }

  const handleEditFieldChange = (field, value) => {
    // if cluster id selected, update selectedCluster
    if (field === 'cluster') {
      const found = clusters.find((cluster) => cluster._id === value)
      if (found) setSelectedCluster(found)
    }
    setEditInfoVisit((prev) => ({ ...(prev || {}), [field]: value }))
  }

  const handleEditDateChange = (e) => {
    const dateValue = e.target.value
    handleEditFieldChange('date', dateValue)
  }

  const handlePhotosChange = (e) => {
    const files = Array.from(e.target.files || [])
    setEditInfoVisit((prev) => ({ ...(prev || {}), newPhotos: files }))
  }

  const handleToggleAttendance = (id) => {
    setEditInfoVisit((prev) => {
      const prevAttendance = Array.isArray(prev?.attendance) ? [...prev.attendance] : []
      const exists = prevAttendance.includes(id)
      const updated = exists ? prevAttendance.filter((att) => att !== id) : [...prevAttendance, id]
      return { ...(prev || {}), attendance: updated }
    })
  }

  // Fetch trainings data and enrich with CLF/VO/SHG names
  const fetchData = (pageNum = 1, sPerPage = 500, filterdata = filterData) => {
    setloading(true)
    getTrainingsForProject(projectId)
      .then(async (data) => {
        setpage(1)
        if (data && Array.isArray(data) && data.length > 0) {
          const updated = await fetchCLFData(data)
          setgroupMeetings(updated)
        } else {
          setgroupMeetings([])
        }
      })
      .catch((error) => {
        console.error('Error fetching Trainings:', error)
        setgroupMeetings([])
      })
      .finally(() => setloading(false))
  }

  const fetchCLFData = async (meetings) => {
    if (!Array.isArray(meetings)) return []
    const updatedMeetings = await Promise.all(
      meetings.map(async (item) => {
        const clfId = item.clfId || null
        const voId = item.voId ? item.voId[0] : null
        const shgId = item.shgId ? item.shgId[0] : null
        let updatedItem = { ...item }
        const fetchDetails = async (id, type) => {
          if (!id) return null
          try {
            const response = await fetch(`${process.env.REACT_APP_HUMBLEBEE_API_URL}/clf/type?id=${id}&type=${type}`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${cookies.get('access_token')}`,
              },
            })
            const res = await response.json()
            if (res.status) return res.data?.name?.trim() || null
          } catch (err) {
            console.error(`Error fetching ${type} details:`, err)
          }
          return null
        }
        const [clfName, voName, shgName] = await Promise.all([
          fetchDetails(clfId, 'clf'),
          fetchDetails(voId, 'vo'),
          fetchDetails(shgId, 'shg'),
        ])
        if (clfName) updatedItem.clfName = clfName
        if (voName) updatedItem.voName = voName
        if (shgName) updatedItem.shgName = shgName
        return updatedItem
      })
    )
    return updatedMeetings
  }

  // Create new training
  const handleCreateTraining = async () => {
    if (!editInfoVisit) {
      alert('No training data to save')
      return
    }
    setloading(true)
    try {
      const newFiles = editInfoVisit.newPhotos || []
      const uploadedUrls = newFiles.length ? await uploadGroupMeetingImages(newFiles, { module: 'group-meeting' }) : []

      const preparedVisit = { ...editInfoVisit, photos: uploadedUrls }
      const payload = buildTrainingPayload(preparedVisit, { projectId, isUpdate: false })

      const missing = validateTrainingPayload(payload)
      if (missing.length > 0) {
        alert('Missing required: ' + missing.join(', '))
        setloading(false)
        return
      }

      const res = await createOrUpdateTraining(payload)
      console.log('Create result', res)

      await fetchData(1, sizePerPage)
      setEditInfoVisit(null)
      setTrainingDetails(false)
      setSeditTrainingDetails(false)
    } catch (err) {
      console.error('Error creating training', err)
      alert('Failed to create training: ' + (err.message || 'Unknown error'))
    } finally {
      setloading(false)
    }
  }

  // Update existing training
  const handleSaveEdit = async () => {
    if (!editInfoVisit) return
    setloading(true)
    try {
      const existingPhotos = editInfoVisit.photos || []
      const newFiles = editInfoVisit.newPhotos || []
      const uploadedUrls = newFiles.length ? await uploadGroupMeetingImages(newFiles, { module: 'group-meeting' }) : []
      const finalPhotos = [...existingPhotos, ...uploadedUrls]

      const preparedVisit = { ...editInfoVisit, photos: finalPhotos }
      const payload = buildTrainingPayload(preparedVisit, { projectId, isUpdate: true })

      const missing = validateTrainingPayload(payload)
      if (missing.length > 0) {
        alert('Missing required: ' + missing.join(', '))
        setloading(false)
        return
      }

      const res = await createOrUpdateTraining(payload)
      console.log('Update result', res)

      await fetchData(page, sizePerPage)
      setEditInfoVisit(null)
      setSeditTrainingDetails(false)
      setTrainingDetails(false)
    } catch (err) {
      console.error('Error saving training', err)
      alert('Failed to save training: ' + (err.message || 'Unknown error'))
    } finally {
      setloading(false)
    }
  }

  // Delete training
  const handleDeleteMeeting = async (id) => {
    if (!id) return
    if (!window.confirm('Delete this training?')) return
    setloading(true)
    try {
      const res = await deleteTraining(id)
      console.log('Delete result', res)
      await fetchData(page, sizePerPage)
      setshowInfoModel(false)
    } catch (err) {
      console.error('Error deleting training', err)
      alert('Failed to delete: ' + (err.message || 'Unknown error'))
    } finally {
      setloading(false)
    }
  }

  // keep filter defaulting to project targeted states when the project loads
  useEffect(() => {
    if (projectInfo && projectInfo.targetedStates) {
      let filterDataCopy = { ...filterData }
      filterDataCopy.state = projectInfo.targetedStates
      setfilterData(filterDataCopy)
      changeStateFilter(projectInfo.targetedStates)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectInfo])

  // ---------- UI render handlers ----------
  const changeFilterHandler = (type, e) => {
    let filterDataCopy = { ...filterData }
    if (type === 'district') {
      filterDataCopy['district'] = e
      if (e.length === 0) filterDataCopy['state'] = []
    } else if (type === 'fromToDate') {
      filterDataCopy['fromDate'] = e[0]
      filterDataCopy['toDate'] = e[1]
    } else if (type === 'state') {
      filterDataCopy['state'] = e
      if (e.length === 0) filterDataCopy['district'] = []
    } else filterDataCopy[type] = e
    setfilterData(filterDataCopy)
    submitFilter(filterDataCopy)
  }

  const changeStateFilter = (e) => {
    let filterDataCopy = { ...filterData }
    filterDataCopy['state'] = e
    if (e.length !== 0) {
      filterDataCopy['district'] = []
      fetch(process.env.REACT_APP_API_URL + '/api/v1/location/districts?states=' + e.join(','), {
        method: 'GET',
        headers: { 'x-auth-token': JSON.parse(readCookie('access_token')) },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) setallDistricts(data.districts)
        })
        .catch((error) => console.error('Error fetching districts:', error))
    }
    setfilterData(filterDataCopy)
    submitFilter(filterDataCopy)
  }

  const submitFilter = (fd) => {
    fetchData(page, sizePerPage, fd)
  }

  const searchFilter = (input, option) => {
    input = input.toLowerCase()
    const children = option.props.children
    if (Array.isArray(children)) {
      return children.some((child) => typeof child === 'string' && child.toLowerCase().includes(input))
    }
    if (typeof children === 'string') return children.toLowerCase().includes(input)
    return false
  }

  const paginationChange = (pageNum, size) => {
    setpage(pageNum)
    setsizePerPage(size)
    fetchData(pageNum, size)
  }

  const onShowSizeChange = (current, s) => {
    setsizePerPage(s)
    setpage(1)
    fetchData(1, s)
  }

  // ---------- render JSX (unchanged layout except heading) ----------
  return (
    <>
      <div className="page-container">
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', marginRight: 100 }}>
          <h2>Trainings {projectInfo ? ' of Project - ' + projectInfo.name : null}</h2>
          <h5>Targeted State {'->'} {projectInfo ? projectInfo.targetedStates.join(', ') : null}</h5>
          <h5>Targeted Districts {'->'} {projectInfo ? projectInfo.targetedDistricts.join(', ') : null}</h5>
        </div>

            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                flexDirection: 'row',
                alignItems: 'end',
                justifyContent: 'start',
                gap: 25,
                marginBottom: 40,
              }}
              className="filters-container"
            >
              <div className="filter form-group">
                <label className="control-label">{'From - To date: '}</label>
                <ConfigProvider locale={enUS}>
                  <RangePicker
                    locale={enUS}
                    style={{ width: '300px' }}
                    format="DD/MM/YYYY"
                    value={[filterData.fromDate, filterData.toDate]}
                    type="date"
                    onChange={changeFilterHandler.bind(this, 'fromToDate')}
                  />
                </ConfigProvider>
              </div>

              <div className="filter form-group">
                <label className="control-label">{'State: '}</label>
                <Select
                  mode="multiple"
                  showSearch
                  style={{ minWidth: '250px', flex: 1 }}
                  value={filterData.state}
                  onChange={changeStateFilter}
                  filterOption={(input, option) => searchFilter(input, option)}
                >
                  <OptGroup label="Focus States">
                    {allStates.map((state, stateIndex) => {
                      if (state.inFocusRegion) {
                        return (
                          <Option key={stateIndex} value={state.name}>
                            {state.name}
                          </Option>
                        )
                      }
                      return null
                    })}
                  </OptGroup>
                </Select>
              </div>

              <div className="filter form-group">
                <label className="control-label">{'District: '}</label>
                <Select
                  mode="multiple"
                  showSearch
                  style={{ minWidth: '250px', flex: 1 }}
                  value={filterData.district}
                  onChange={changeFilterHandler.bind(this, 'district')}
                  filterOption={(input, option) => searchFilter(input, option)}
                >
                  {filterData.state
                    ? allDistricts.map((district, districtIndex) => {
                        let districtName = district.name
                        if (district.state) districtName += ' (' + district.state + ')'
                        return (
                          <Option value={district.name} key={districtIndex}>
                            {districtName}
                          </Option>
                        )
                      })
                    : null}
                </Select>
              </div>

              <div className="filter form-group">
                <button className="btn reset-filters" onClick={resetFilter}>
                  Reset
                </button>
              </div>
            </div>

            <div style={{ marginTop: 20, width: '100%', display: 'flex', justifyContent: 'start', alignItems: 'center', flexWrap: 'wrap', gap: 10, minHeight: '300px' }}>
              {loading ? (
                <div style={{ width: '100%', justifyContent: 'center', display: 'flex', padding: '60px 0' }}>
                  <Spin size="large" tip="Loading Trainings Data..." />
                </div>
              ) : groupMeetings && groupMeetings.length > 0 ? (
                groupMeetings.map((item, idx) => {
                  console.log('Rendering training item', item)
                  return (
                  <div
                    key={item._id || idx}
                    style={{
                      width: window.innerWidth > 1300 ? 'calc(25% - 20px)' : window.innerWidth > 900 ? 'calc(33% - 20px)' : window.innerWidth > 500 ? 'calc(50% - 20px)' : 'calc(100% - 20px)',
                      padding: 10,
                      border: '1px solid #efefef',
                      boxShadow: '1px 1px 1px #ddd',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      minHeight: '500px',
                    }}
                  >
                    <Carousel controls={false} interval={3000} indicators={false}>
                      {(item.photos || []).map((image, imageIndex) => (
                        <Carousel.Item key={imageIndex}>
                          <img style={{ width: '100%', borderRadius: 5, height: 200, objectFit: 'cover' }} src={image} alt="img" />
                        </Carousel.Item>
                      ))}
                    </Carousel>

                    <div style={{ display: 'flex', alignItems: 'left', flexDirection: 'column', gap: 5, margin: '10px 5px' }}>
                      <div className="activity-date-container">
                        <span className="label">Training Date: </span>
                        <span className="value">{item.date ? moment(item.date).format('DD/MM/YYYY') : 'N/A'}</span>
                        <div className="activity-date-container">
                          <span className="label">Total Attendences: </span>
                          <span className="value">{item.attendance.length}</span>
                        </div>
                        <div className="activity-date-container">
                          <span className="label">Topics: </span>
                          <span className="value">{item.topics || item.title}</span>
                        </div>
                        <div>
                          <p>CLF: {item.clfName ? item.clfName : 'N/A'}</p>
                          <p>VO: {item.voName ? item.voName : 'N/A'}</p>
                          <p>SHG: {item.shgName ? item.shgName : 'N/A'}</p>
                        </div>
                      </div>

                      <div className="activity-date-container">
                        <span className="label">District: </span>
                        <span className="value">{item.location ?? "N/A"}</span>
                      </div>
                      <div className="activity-date-container">
                        <span className="label">Created By: </span>
                        <span className="value">{item.added_by?.name ?? "N/A"}</span>
                      </div>
                    </div>

                    <div
                      style={{ width: '100%', color: '#fff', cursor: 'pointer', textAlign: 'center', background: 'var(--themeColor)', padding: '8px 0' }}
                      onClick={() => { setshowInfoModel(true); setshowInfoVisit(item); }}
                    >
                      See More
                    </div>
                  </div>
                )})
              ) : (
                <div style={{ width: '100%', justifyContent: 'center', display: 'flex', marginRight: 100 }}>
                  <h2>No Trainings Data is Available</h2>
                </div>
              )}
            </div>
        {groupMeetings.length > 0 && (
          <div style={{ paddingTop: 40 }} className="pagination-container text-center mt15">
            <Pagination showSizeChanger onChange={paginationChange} onShowSizeChange={onShowSizeChange} current={page} total={groupMeetings.length} pageSize={sizePerPage} pageSizeOptions={['100', '500', '1000', '2000', '3000', '5000']} />
          </div>
        )}
      </div>

      {/* SHOW modal */}
      {showInfoModel && showInfoVisit ? (
        <Modal centered className="show-activity-modal" show={showInfoModel} onHide={() => setshowInfoModel(false)} size="lg" aria-labelledby="contained-modal-title-lg">
          <Modal.Body className="show-activity-modal-body">
            <Row>
              <Col md={5}>
                <div className="activity-img-container">
                  {showInfoVisit.photos && showInfoVisit.photos.length > 0 ? (
                    <Carousel controls={false} interval={3000} indicators={false}>
                      {showInfoVisit.photos.map((image, imageIndex) => (
                        <Carousel.Item key={imageIndex}>
                          <img alt="" className="d-block" src={image} />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  ) : (
                    <div>
                      <img alt="" className="d-block w-100" src="/images/image-upload.png" />
                    </div>
                  )}
                </div>
              </Col>

              <Col md={7} className="selected-activity-details">
                <div className="activity-date-container">
                  <span className="label">Training Date: </span>
                  <span className="value">{showInfoVisit.date ? moment(showInfoVisit.date).format('DD/MM/YYYY') : ''}</span>
                </div>
                <div className="activity-date-container">
                  <span className="label">Total Attendences: </span>
                  <span className="value">{showInfoVisit.attendance.length}</span>
                </div>
                <div className="activity-date-container">
                  <span className="label">Total Women Attendences: </span>
                  <span className="value">{showInfoVisit.no_of_women}</span>
                </div>
                <div className="activity-date-container">
                  <span className="label">Topics: </span>
                  <span className="value">{showInfoVisit.topics || showInfoVisit.title}</span>
                </div>

                <div className="activity-date-container">
                  <span className="label">CLF: </span>
                  <span className="value">{showInfoVisit.clfName ? showInfoVisit.clfName : 'N/A'}</span>
                </div>

                <div className="activity-date-container">
                  <span className="label">State: </span>
                  <span className="value">{(showInfoVisit.location && (() => { try { return JSON.parse(showInfoVisit.location).state } catch (e) { return showInfoVisit.location?.state } })()) || showInfoVisit.location?.state}</span>
                </div>
                <div className="activity-date-container">
                  <span className="label">District: </span>
                  <span className="value">{(showInfoVisit.location && (() => { try { return JSON.parse(showInfoVisit.location).district } catch (e) { return showInfoVisit.location?.district } })()) || showInfoVisit.location?.district}</span>
                </div>
                <div className="activity-date-container">
                  <span className="label">Block: </span>
                  <span className="value">{(showInfoVisit.location && (() => { try { return JSON.parse(showInfoVisit.location).block } catch (e) { return showInfoVisit.location?.block } })()) || showInfoVisit.location?.block}</span>
                </div>
                <div className="activity-date-container">
                  <span className="label">Venue: </span>
                  <span className="value">{showInfoVisit.venue || (showInfoVisit.location && (() => { try { return JSON.parse(showInfoVisit.location).address } catch (e) { return showInfoVisit.location?.address } })())}</span>
                </div>
                <div className="activity-date-container">
                  <span className="label">Community Anchor Name: </span>
                  <span className="value">{showInfoVisit.community_anchor?.name}</span>
                </div>

                <div className="description">
                  <span className="label">Training Notes And Outcomes: </span>
                  {showInfoVisit.notes}
                </div>
                <div className="description">
                  <span className="label"> Next Steps: </span>
                  {showInfoVisit.next_steps}
                </div>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Col className="flex justify-content-between">
              {/* <Button style={{ color: '#fff', cursor: 'pointer', textAlign: 'center', background: 'var(--themeColor)', padding: '16px' }} onClick={() => handleEditInfoModal()}>
                Edit
              </Button>
              <Button style={{ color: '#fff', cursor: 'pointer', textAlign: 'center', padding: '16px', marginLeft: '10px' }} variant="danger" onClick={() => handleDeleteMeeting(showInfoVisit._id)}>
                Delete
              </Button> */}
            </Col>
          </Modal.Footer>
        </Modal>
      ) : null}

      {/* EDIT modal */}
      {/* {editTrainingDetails && editInfoVisit ? (
        <Modal centered className="show-activity-modal" show={!!editInfoVisit} onHide={handleCloseEditModal} size="lg" aria-labelledby="contained-modal-title-lg">
          <Modal.Body className="show-activity-modal-body" style={{ padding: '24px 24px 16px' }}>
            <h4 style={{ marginBottom: 24, fontWeight: 600 }}>Edit Training</h4>

            <Row style={{ marginBottom: 16 }}>
              <Col md={4} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Select Cluster
                </label>
                <Form.Control as="select" value={editInfoVisit.cluster || ''} onChange={(e) => handleEditFieldChange('cluster', e.target.value)}>
                  <option value="" disabled>
                    Select Cluster
                  </option>
                  {clusters.map((cluster) => (
                    <option value={cluster._id} key={cluster._id}>
                      {cluster.clusterName}
                    </option>
                  ))}
                </Form.Control>
              </Col>

              <Col md={4} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Date
                </label>
                <Form.Control type="date" value={editInfoVisit.date ? moment(editInfoVisit.date).format('YYYY-MM-DD') : ''} onChange={handleEditDateChange} />
              </Col>

              <Col md={4} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Venue
                </label>
                <Form.Control type="text" value={editInfoVisit.venue || ''} onChange={(e) => handleEditFieldChange('venue', e.target.value)} />
              </Col>
            </Row>

            <Row style={{ marginBottom: 16 }}>
              <Col md={6} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Topics Covered
                </label>
                <Form.Control type="text" placeholder="Beekeeping Scientific Techniques" value={editInfoVisit.topicsCovered || ''} onChange={(e) => handleEditFieldChange('topicsCovered', e.target.value)} />
              </Col>

              <Col md={6} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Led by
                </label>
                <Form.Control type="text" placeholder="Trainer name" value={editInfoVisit.ledBy || ''} onChange={(e) => handleEditFieldChange('ledBy', e.target.value)} />
              </Col>
            </Row>

            <div style={{ marginBottom: 16 }}>
              <label className="control-label" style={{ fontWeight: 500 }}>
                Description
              </label>
              <Form.Control as="textarea" rows={4} placeholder="Add description" value={editInfoVisit.notes || ''} onChange={(e) => handleEditFieldChange('notes', e.target.value)} />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label className="control-label" style={{ fontWeight: 500 }}>
                Add Photos
              </label>
              <div style={{ marginTop: 8 }}>
                <Form.Control type="file" multiple onChange={handlePhotosChange} accept="image/*" />
                {editInfoVisit.photos && editInfoVisit.photos.length > 0 && <small style={{ display: 'block', marginTop: 4 }}>{editInfoVisit.photos.length} file(s) already present</small>}
                {editInfoVisit.newPhotos && editInfoVisit.newPhotos.length > 0 && <small style={{ display: 'block', marginTop: 4 }}>{editInfoVisit.newPhotos.length} new file(s) chosen</small>}
              </div>
            </div>

            <div>
              <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 8 }}>
                {editInfoVisit.cluster && (
                  <div>
                    <h2 style={{ margin: 0 }}>Attendance</h2>
                    <small>Toggle to add attendance</small>
                  </div>
                )}

                {editInfoVisit.cluster && trainees[editInfoVisit.cluster] && (
                  <span style={{ fontWeight: 500 }}>
                    {trainees[editInfoVisit.cluster].filter((a) => editInfoVisit?.attendance?.includes(a._id)).length} / {trainees[editInfoVisit.cluster].length}
                  </span>
                )}
              </div>

              {editInfoVisit.cluster && trainees[editInfoVisit.cluster] && trainees[editInfoVisit.cluster].map((attendee, index) => {
                return (
                  <div key={attendee._id || index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0' }}>
                    <span>{attendee.le_app_user_id?.name || '—'}</span>
                    <Form.Check type="switch" id={`attendance-${index}`} checked={Array.isArray(editInfoVisit?.attendance) ? editInfoVisit.attendance.includes(attendee._id) : false} onChange={() => handleToggleAttendance(attendee._id)} />
                  </div>
                )
              })}
            </div>
          </Modal.Body>

          <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, padding: '12px 24px 20px' }}>
            <Button variant="secondary" onClick={handleCloseEditModal} style={{ minWidth: 100 }}>
              Cancel
            </Button>
            <Button style={{ background: 'var(--themeColor)', borderColor: 'var(--themeColor)', minWidth: 100 }} onClick={handleSaveEdit}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      ) : null} */}

      {/* ADD modal */}
      {/* {addTrainingDetails && editInfoVisit ? (
        <Modal centered className="show-activity-modal" show={!!editInfoVisit} onHide={handleCloseEditModal} size="lg" aria-labelledby="contained-modal-title-lg">
          <Modal.Body className="show-activity-modal-body" style={{ padding: '24px 24px 16px' }}>
            <h4 style={{ marginBottom: 24, fontWeight: 600 }}>Add Training</h4>

            <Row style={{ marginBottom: 16 }}>
              <Col md={4} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Select Cluster
                </label>
                <Form.Control as="select" value={editInfoVisit.cluster || ''} onChange={(e) => handleEditFieldChange('cluster', e.target.value)}>
                  <option value="" disabled>
                    Select Cluster
                  </option>
                  {clusters.map((cluster) => (
                    <option value={cluster._id} key={cluster._id}>
                      {cluster.clusterName}
                    </option>
                  ))}
                </Form.Control>
              </Col>

              <Col md={4} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Date
                </label>
                <Form.Control type="date" value={editInfoVisit.date ? moment(editInfoVisit.date).format('YYYY-MM-DD') : ''} onChange={handleEditDateChange} />
              </Col>

              <Col md={4} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Venue
                </label>
                <Form.Control type="text" value={editInfoVisit.venue || ''} onChange={(e) => handleEditFieldChange('venue', e.target.value)} />
              </Col>
            </Row>

            <Row style={{ marginBottom: 16 }}>
              <Col md={6} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Topics Covered
                </label>
                <Form.Control type="text" value={editInfoVisit.topicsCovered || ''} onChange={(e) => handleEditFieldChange('topicsCovered', e.target.value)} />
              </Col>

              <Col md={6} style={{ marginBottom: 12 }}>
                <label className="control-label" style={{ fontWeight: 500 }}>
                  Led by
                </label>
                <Form.Control type="text" placeholder="Trainer name" value={editInfoVisit.ledBy || ''} onChange={(e) => handleEditFieldChange('ledBy', e.target.value)} />
              </Col>
            </Row>

            <div style={{ marginBottom: 16 }}>
              <label className="control-label" style={{ fontWeight: 500 }}>
                Description
              </label>
              <Form.Control as="textarea" rows={4} placeholder="Add description" value={editInfoVisit.notes || ''} onChange={(e) => handleEditFieldChange('notes', e.target.value)} />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label className="control-label" style={{ fontWeight: 500 }}>
                Add Photos
              </label>
              <div style={{ marginTop: 8 }}>
                <Form.Control type="file" multiple onChange={handlePhotosChange} accept="image/*" />
                {editInfoVisit.photos && editInfoVisit.photos.length > 0 && <small style={{ display: 'block', marginTop: 4 }}>{editInfoVisit.photos.length} file(s) already present</small>}
                {editInfoVisit.newPhotos && editInfoVisit.newPhotos.length > 0 && <small style={{ display: 'block', marginTop: 4 }}>{editInfoVisit.newPhotos.length} new file(s) chosen</small>}
              </div>
            </div>

            <div>
              <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 8 }}>
                {editInfoVisit.cluster && (
                  <div>
                    <h2 style={{ margin: 0 }}>Attendance</h2>
                    <small>Toggle to add attendance</small>
                  </div>
                )}

                {editInfoVisit.cluster && trainees[editInfoVisit.cluster] && (
                  <span style={{ fontWeight: 500 }}>
                    {trainees[editInfoVisit.cluster].filter((a) => editInfoVisit?.attendance?.includes(a._id)).length} / {trainees[editInfoVisit.cluster].length}
                  </span>
                )}
              </div>

              {editInfoVisit.cluster && trainees[editInfoVisit.cluster] && trainees[editInfoVisit.cluster].map((attendee, index) => {
                return (
                  <div key={attendee._id || index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0' }}>
                    <span>{attendee.le_app_user_id?.name || '—'}</span>
                    <Form.Check type="switch" id={`attendance-add-${index}`} checked={Array.isArray(editInfoVisit?.attendance) ? editInfoVisit.attendance.includes(attendee._id) : false} onChange={() => handleToggleAttendance(attendee._id)} />
                  </div>
                )
              })}
            </div>
          </Modal.Body>

          <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, padding: '12px 24px 20px' }}>
            <Button variant="secondary" onClick={() => setTrainingDetails(false)} style={{ minWidth: 100 }}>
              Cancel
            </Button>
            <Button style={{ background: 'var(--themeColor)', borderColor: 'var(--themeColor)', minWidth: 100 }} onClick={handleCreateTraining}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      ) : null} */}
    </>
  )
}

export default TrainingDetails
